module.exports = __webpack_public_path__ + "static/media/squared.3448e467.jpg";